import { HttpClient } from 'api/http-client';
class ProjectAccountingHttpClient extends HttpClient {
    getFinancialNotificationConfig() {
        return this.get('/account-notification-config');
    }
    updateFinancialNotificationConfig(configId, payload) {
        return this.put(`/account-notification-config/${configId}`, payload);
    }
    getRevenueRecognitionConfig() {
        return this.get('/revenue-recognition-config');
    }
    updateRevenueRecognitionConfig(payload) {
        return this.put('/revenue-recognition-config', payload);
    }
    getCustomRevenueRecognitionConfig(includeProjects) {
        return this.get(`/revenue-recognition-config/custom?lastestVersion=true${includeProjects ? '&includeProjects=true' : ''}`);
    }
    getCustomRevenueRecognitionProjectCount() {
        return this.get('/revenue-recognition-config/project-count');
    }
    createCustomRevenueRecognitionConfig(payload) {
        return this.post('/revenue-recognition-config/custom', payload);
    }
    updateCustomRevenueRecognitionConfig(customRevenueRecognitionId, payload) {
        return this.put(`/revenue-recognition-config/custom/${customRevenueRecognitionId}`, payload);
    }
    deleteCustomRevenueRecognitionConfig(customRevenueRecognitionId) {
        return this.delete(`/revenue-recognition-config/custom/${customRevenueRecognitionId}`);
    }
    getFinancialsConfiguration() {
        return this.get('/financials/configuration');
    }
    updateFinancialsConfiguration(payload) {
        return this.put('/financials/configuration', payload);
    }
}
export const ProjectAccountingAPI = new ProjectAccountingHttpClient();
